import React, { useState } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import Pagination from "../../../../components/Pagination";

const LeaveHistory = ({ leaveHistory, onEdit, showAction, title,onCancel }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(5);
  // const itemsPerPage = 5;

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };

  const recordsPerPageOption = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: leaveHistory.length, label: "All" },
  ];

  // Calculate the index of the first and last items on the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Get current items for the page
  const currentItems = leaveHistory.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="container-fluid" id="skill-table-area">
        <div className="row p-1">
          <h6>
            <b>{title}</b>
          </h6>
          <div className="box-body table-responsive px-2">
            <Table striped bordered hover>
              <thead id="thcolor" className="text-center">
                <tr>
                  <th className="py-1 px-2">Applied On</th>
                  <th className="py-1 px-2">From</th>
                  <th className="py-1 px-2">To</th>
                  <th className="py-1 px-2">Status</th>
                  {showAction && <th className="py-1 px-2">Action</th>}
                </tr>
              </thead>
              <tbody className="text-center">
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="py-1 px-2">
                      No Record
                    </td>
                  </tr>
                ) : (
                  currentItems.map((leave, index) => (
                    <tr key={index}>
                      <td className="py-1 px-2">
                        {moment(leave.TXNDate).format("DD-MMM-YYYY")}
                      </td>
                      <td className="py-1 px-2">
                        {moment(leave.FromDate).format("DD-MMM-YYYY")}
                      </td>
                      <td className="py-1 px-2">
                        {moment(leave.ToDate).format("DD-MMM-YYYY")}
                      </td>
                      <td className="py-1 px-2">{leave.ApplicationStatus}</td>
                      {showAction && (
                        <td className="py-1 px-2">
                          
                           <div className="d-flex">
                            <OverlayTrigger
                            placement="bottom"
                            overlay={
                              leave.ApplicationStatus === "Pending" ? (
                                <Tooltip id="tooltip-bottom">Edit</Tooltip>
                              ) : (
                                <></>
                              )
                            }
                          >
                             <div
                              className={`me-2 ${
                                leave.ApplicationStatus !== "Pending"
                                  ? "icon-disabled"
                                  : ""
                              }`}
                            >
                              <i
                                className="bi bi-pencil-square"
                                onClick={
                                  leave.ApplicationStatus === "Pending"
                                    ? () => onEdit(leave.ID)
                                    : null
                                }
                              ></i>
                            </div></OverlayTrigger>
                            <OverlayTrigger
                            placement="bottom"
                            overlay={
                              leave.ApplicationStatus === "Pending" ? (
                                <Tooltip id="tooltip-bottom">Cancel</Tooltip>
                              ) : (
                                <></>
                              )
                            }
                          >
                            <div
                              className={`me-2 ${
                                leave.ApplicationStatus !== "Pending"
                                  ? "icon-disabled"
                                  : ""
                              }`}
                            >
                              <i
                                className="bi bi-x-square"
                                onClick={
                                  leave.ApplicationStatus === "Pending"
                                    ? () => onCancel(leave)
                                    : null
                                }
                              ></i>
                            </div>
                          </OverlayTrigger>
                           </div>
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </div>
        {/* Pagination Component */}
      <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between">
  {/* 1️⃣  Text on the left, per‑page dropdown on the right */}
  <div className="d-flex justify-content-between px-2">
    <span style={{ width:"130px" }}>
      Showing {(currentPage - 1) * selectedRecordsPerPage + 1} –{" "}
      {Math.min(currentPage * selectedRecordsPerPage, currentItems.length)} of{" "}
      {leaveHistory.length}
    </span>

   <div style={{ width:"80px" }}>
    <select
      value={selectedRecordsPerPage}
      onChange={handleRecordsPerPage}
      className="form-select form-select-sm ms-2"
    >
      {recordsPerPageOption.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
    </div>
  </div>

  {/* 2️⃣  Pagination centred on small screens, right‑aligned ≥ 576 px */}
  <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-100">
    <Pagination
      itemsPerPage={selectedRecordsPerPage}
      totalItems={leaveHistory.length}
      currentPage={currentPage}
      onPageChange={handlePageChange}
    />
  </div>
</div>

      </div>
    </>
  );
};

export default LeaveHistory;
